import { ModalTiteledWindow } from "./modalWindow.js";
import { DateSelect } from "../dateSelect.js";
import { RadioButtons } from "../radiobuttons.js";
import { Validator } from "../validator.js";
import { ModalConfirm } from "./modalConfirm.js";
import { MultiSelect } from "../multiSelect.js";

export class ModalEditClassNote extends ModalTiteledWindow {
    constructor(app, initData) {

        super();
        this.setTitle('Klassenbuch-Anmerkung <span class="help icon-info" selector=".classnote-info"></span>');

        this.app = app;
        this.dm = app.dm;
        this.user = this.dm.getUserSelf();

        const defaults = {
            visibleForTeachers: 1,
            classes: [],
            note: '',
        };

        this.initData = Object.extend(true, defaults, initData);

        this.elMain = HTMLElement.createFromHTML(
              '<div class="modal-edit-class-note">'
            + '   <div class="settings-item info">'
            + '      <div class="sync-status"><i class="icon icon-refresh"></i><span class="icon error">!</span></div>'
            + '      <div class="message"></div>'
            + '   </div>'
            + '   <div class="settings-item date">'
            + '      <div class="title"><span>Anzeigezeitraum <span class="date-value"></span></span><span class="help icon-info" selector=".classnote-date"></span></div>'
            + '      <div class="content">'
            + '         <div class="validation-error-message"></div>'
            + '      </div>'
            + '   </div>'
            + '   <div class="settings-item permission">'
            + '      <div class="title">Sichtbar für<span class="help icon-info" selector=".classnote-permission"></span></div>'
            + '      <div class="content">'
            + '         <div class="validation-error-message"></div>'
            + '      </div>'
            + '   </div>'
            + '   <div class="settings-item classes">'
            + '      <div class="title">Klassen<span class="help icon-info" selector=".classnote-classes"></span></div>'
            + '      <div class="content">'
            + '         <div class="validation-error-message"></div>'
            + '      </div>'
            + '   </div>'
            + '   <div class="settings-item message">'
            + '      <div class="title">Nachricht<span class="help icon-info" selector=".classnote-message"></span></div>'
            + '      <div class="content">'
            + '         <div class="validation-error-message"></div>'
            + '         <textarea rows="3" type="text" class="txt-message"></textarea>'
            + '      </div>'
            + '   </div>'
            + '   <div class="buttons bottom-bar">'
            + '      <i class="btn-delete icon-trash button-circle"></i>'            
            + '      <i class="btn-save icon-check button-circle"></i>'
            + '   </div>'
            + '</div>'
        );

        // Buttons zum Löschen und Speichern aktivieren / deaktivieren
        if (this.initData.creatorId === this.user.id) {
            this.elMain.querySelector('.btn-save').onclick = () => this.save();
        }
        else {
            this.elMain.querySelector('.btn-save').style.filter = 'grayscale(1) brightness(1.5)';
        }

        if (this.initData.creatorId === this.user.id && (this.initData.localId || this.initData.saveOnlineOnly)) {
            this.elMain.querySelector('.btn-delete').onclick = () => this.delete();
        }
        else {
            this.elMain.querySelector('.btn-delete').style.filter = 'grayscale(1) brightness(1.5)';
        }

        if (this.initData.creatorId === this.user.id && this.initData.syncStatus === 'update') {
            this.elMain.querySelector('.info .sync-status').classList.add('update');
            this.elMain.querySelector('.info .message').innerHTML = "Dieser Eintrag wurde noch nicht synchronisiert.";
        }
        else if (this.initData.syncStatus === 'error') {
            this.elMain.querySelector('.info .sync-status').classList.add('error');
            this.elMain.querySelector('.info .message').innerHTML = "Fehler beim Synchronisieren: " + this.initData.errorMessage;
        }
        else {
            this.elMain.querySelector('.info').style.display = 'none';
        }

        //this.elMain.querySelector('.btn-save').onclick = () => this.save();

        // Datum
        this.dateSelect = new DateSelect({ range: true , onSelect: (from, to) => this.setDate(from, to) });
        this.elMain.querySelector('.settings-item.date .content').prepend(this.dateSelect.getElement());

        // Sichtbar für
        this.permission = new RadioButtons('permission',
            { /*onSelect: (value) => {}*/ },
            [
                { label: "mich",         value: "noone" },
                { label: "Lehrer",       value: "teachers" },
                { label: "Lehrer & SuS", value: "pupils" }
                /*{ label: "jeden",   value: "all" }*/
            ]
        );
        this.permission.setValue('teachers');

        this.elMain.querySelector('.settings-item.permission .content').prepend(this.permission.getElement());

        // Klassen
        this.classes = new MultiSelect({
            getItems: () => this.getClassList(),
            /*onChange: (classes) => this.setClasses(classes),*/
            itemTextValue: (cls) => cls.name,
            itemSortValue: (cls) => cls.name.replace(/^(\d[^\d])/, "0$1"),
            itemId: (cls) => cls.id,
            listSettings: {
                columns: [
                    { title: '', data: (cls) => cls.name, class: () => 'equal-width' }
                ]
             }            
        });

        this.elMain.querySelector('.settings-item.classes .content').prepend(this.classes.getElement());

        // Titel
        this.elMessage = this.elMain.querySelector('.settings-item.message .txt-message');
        this.elNotes = this.elMain.querySelector('.settings-item.notes .txt-notes');

        this.loadData(this.initData);
        this.appendToBody(this.elMain);
        this.setupHelp(this.app);
        setTimeout(() => this.show(), 1);
    }

    save() {

        let val = new Validator([
            {
                name: 'date',
                element: this.dateSelect.getElement(),
                get: () => {
                    //const d = this.dateSelect.getSelection();
                    //return { from: d.from.isoDate(), to: d.to.isoDate() }
                    return this.dateSelect.getSelection();
                },
                validate: { 'dateRange': true },
                error: { element: this.elMain.querySelector('.settings-item.date .validation-error-message'), message: "Bitte geben Sie das Datum an." }
            },
            {
                name: 'permission',
                element: this.permission.getElement(),
                get: () => this.permission.getValue(),
                //validate: { 'strMinLen': 1 },
                //error: { element: this.elMain.querySelector('.reg-content .validation-error-message'), message: "Bitte geben Sie das Stundenthema an." }
            },
            {
                name: 'classes',
                element: this.elMain.querySelector('.settings-item.classes'),
                get: () => this.classes.getSelectedItemIds(),
                validate: { 'arrayMinLen': 1 },
                error: { element: this.elMain.querySelector('.settings-item.classes .validation-error-message'), message: "Bitte wählen Sie mindestens eine Klasse" }
            },
            {
                name: 'note',
                element: this.elMessage,
                get: () => this.elMessage.value,
                validate: { 'strMinLen': 1 },
                error: { element: this.elMain.querySelector('.settings-item.message .validation-error-message'), message: "Bitte geben Sie die Nachricht an." }
            }/*,
            {
                name: 'notes',
                get: () => this.elNotes.value
            },*/
        ]);

        let valiData = val.validate();

        if (valiData) {
            valiData.dateFrom = valiData.date.from.isoDate();
            valiData.dateTo   = valiData.date.to.isoDate();
            delete valiData.date;

            valiData.visibleForTeachers = valiData.permission === 'teachers' || valiData.permission === 'pupils' || valiData.permission === 'all';
            valiData.visibleForPupils   = valiData.permission === 'pupils' || valiData.permission === 'all';
            delete valiData.permission;

            valiData.type = 'classNote';

            let data = Object.extend(true, this.initData, valiData);
            if (!data.creatorId) data.creatorId = this.user.id;
            this.close();
            
            this.dm.saveClassNote(data).then(() => {
                this.app.classReg.redrawBuffer();
            });
        }

    }

    delete() {

        if (!this.initData.localId && !this.initData.saveOnlineOnly) return;

        new ModalConfirm(
            "Soll diese Klassenbuch-Anmerkung wirklich gelöscht werden?",
            async (confirmed) => {
                if (confirmed) {
                    await this.dm.deleteClassNote(this.initData);
                    this.app.classReg.redrawBuffer();
                    this.close();
                }
            }
        );

    }

    setDate(from, to) {
        if (!from) {
            this.elMain.querySelector('.settings-item.date .title .date-value').innerHTML = '';
        }
        else if (to) this.elMain.querySelector('.settings-item.date .title .date-value').innerHTML = Date.simplifyDatePeriod(from.isoDate(), to.isoDate());
        else this.elMain.querySelector('.settings-item.date .title .date-value').innerHTML = from.toGermanDate();
    }

    getClassList() {
        let classes = Object.values(this.dm.getClasses());

        return {
            list:    classes.filter(cls => !cls.teachers.find(t => t.id === this.user.id)),
            favList: classes.filter(cls => cls.teachers.find(t => t.id === this.user.id)),
        };
    }

    loadData(data) {

        this.dateSelect.select(data.dateFrom ? new Date(Date.fromString(data.dateFrom)) : false, data.dateTo? new Date(Date.fromString(data.dateTo)) : false, true);
        this.classes.setSelection(data.classes);
        this.elMessage.value = data.note;

        if (data.visibleForTeachers === 1 && data.visibleForPupils === 1)
            this.permission.setValue('pupils');
        else if (data.visibleForTeachers === 1)
            this.permission.setValue('teachers');
        else
            this.permission.setValue('noone');
        
    }


}

